<template>
  <div class="app_box">
    <div class="box1">
    <div class="logo">SIMABA III IMP&EXP  S.L<br/>管理系统</div>

    </div>
    <div class="box2">
      <el-menu :default-active="$route.name" class="el-menu-vertical-demo" background-color="#314158" text-color="#428bca"
      active-text-color="#fff" active-background-color="#333" router unique-opened>
      <template v-for="(menu,index) in menus">
        
        <el-menu-item :index="menu.name" :route="{path:menu.path}" class="boxa" >
          <span slot="title">{{menu.name2}}</span>
        </el-menu-item>
      </template>

    </el-menu>
    </div>
    
  </div>
</template>

<script>

  export default {
    data() {
      return {
        menus: [{
            name: 'parameter',
            name2: '参数设置',
            path: '/home/parameter'
          },
          {
            name: 'case',
            name2: '案例展示',
            path: '/home/case'
          }, {
            name: 'team',
            name2: '我们的团队',
            path: '/home/team'
          }, {
            name: 'upload',
            name2: '图片上传',
            path: '/home/upload'
          }, {
            name: 'Administrator',
            name2: '管理员',
            path: '/home/Administrator'
          },
         
        ],

      };
    },
    methods: {
      exit() {
        
      }
    }
  }
</script>

<style lang="less" scoped>
.app_box{
  height: 100%;
}
.logo{
  width: 100%;
  height: 60px;
  background-color: #314158;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
  .el-menu {
    border: none !important;
  }

  .el-menu-item {  
    color: #fff;
    width: 100%;
  }

  .el-menu-item:hover {
    background-color: #428bca !important;
    
    color: #fff !important;
  }

  .el-menu-item.is-active {
    background-color: #428bca !important;
    
    color: #fff;

    span {
      color: #fff !important;
    }
  }
</style>